import { render, staticRenderFns } from "./ApprovalCard.vue?vue&type=template&id=35e69897&"
import script from "./ApprovalCard.vue?vue&type=script&lang=js&"
export * from "./ApprovalCard.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalCard.vue?vue&type=style&index=0&id=35e69897&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports